export default "__VITE_ASSET__DKYSP24B__"